// src/SignIn.js
import React, { useState } from "react";
import { login } from "./api";

export default function SignIn({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const data = await login(email.trim(), password.trim());

      // Backend sets cookie; we pass back the full user payload
      if (onLogin) {
        if (data && typeof data === "object") {
          onLogin(data);
        } else {
          onLogin({ email: email.trim() });
        }
      }
    } catch (err) {
      const msg =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        err?.message ||
        "Login failed";
      setError(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ maxWidth: 420, margin: "15vh auto", textAlign: "center" }}>
      <h2>Sign in to Feature Flags</h2>
      <p>Enter your credentials.</p>
      <form onSubmit={handleSubmit} style={{ marginTop: 16, textAlign: "left" }}>
        <label style={{ display: "block", marginBottom: 4 }}>Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="sajatha@rohirrim.ai"
          style={{ width: "100%", padding: 8, marginBottom: 8 }}
        />

        <label style={{ display: "block", marginBottom: 4 }}>Password</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          style={{ width: "100%", padding: 8, marginBottom: 8 }}
        />

        {error && (
          <div style={{ color: "red", fontSize: 14, marginBottom: 8 }}>
            {error}
          </div>
        )}

        <button type="submit" disabled={busy} style={{ padding: "6px 16px" }}>
          {busy ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
